export default __webpack_public_path__ + "static/media/pisa.820fd0fd.png";